import { MessageService } from 'primeng/primeng';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { Channel } from '../../models/loyalty-channel.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class LoyaltyChannelService {

  public baseUrl = HttpClientService.BASE_MS_LOYALTY;
  public baseUrlChannel = this.baseUrl + '/channel/';
  private cache = new Map<string, Channel>();
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(channelId): Observable <Channel> {

    if (this.cache.has(channelId)) {
      return Observable.of(this.cache.get(channelId));
    }

    return this.http.get(this.baseUrlChannel + channelId ).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<Channel>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    return this.http.getPaged(this.baseUrlChannel + 'getChannelList?' + params.toString());
  }

  update(channel: Channel): Observable<Channel> {
    return this.http.put(this.baseUrlChannel + channel.id, channel).map(res => {
      this.cache.delete(channel.id);
      return res;
    });
  }

  create(channel: Channel): Observable<Channel> {
    return this.http.post(this.baseUrlChannel,  channel);
  }

  remove(channelId): Observable<Channel> {
    return this.http.delete(this.baseUrlChannel + channelId).map(res => {
      this.cache.delete(channelId);
      return res;
    });
  }
  recover(channel) {
    return this.http.put(this.baseUrl + "/channel/recover/" + channel.id, channel)
      .map(res => {
        this.cache.delete(channel.id);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/ChannelDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getAllChannels() {
    return this.http.get(this.baseUrlChannel);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-channel.service.ts